import { render, staticRenderFns } from "./ChatbotPlanification.vue?vue&type=template&id=f21fc16a"
import script from "./ChatbotPlanification.vue?vue&type=script&lang=js"
export * from "./ChatbotPlanification.vue?vue&type=script&lang=js"
import style0 from "./ChatbotPlanification.vue?vue&type=style&index=0&id=f21fc16a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports